import React from 'react';
import './panels.css';

// Demo is hosted on the company WordPress site and embedded via URL — the
// ~29 MB file is deliberately NOT committed to the repo.
const DEMO_URL =
  'https://www.fintext.io/wp-content/uploads/2025/04/Stedili-Demo-Compressed.mp4';

// Two independent cards side by side: pool-blue CTA (narrow, left) + dark
// video card (wide, right). Copy is Lorem Ipsum apart from the demo heading.
const DualCard = () => (
  <div className="sd-dual-card">
    <div className="sd-card sd-card--cta">
      <h2 className="sd-h2">Watch a one minute demo</h2>
    </div>
    <div className="sd-card sd-card--dark">
      <video
        className="sd-video-embed"
        src={DEMO_URL}
        controls
        playsInline
        preload="metadata"
      />
    </div>
  </div>
);

export default DualCard;
